// ikick custom
/* ═══════════════════════════════════════════════════════════
   IKICK — Custom Theme JavaScript
   Version: 1.0.0
═══════════════════════════════════════════════════════════ */

(function() {
'use strict';

/* ══ 1. SCROLL PROGRESS + BACK TO TOP ══════════════════════ */
var progressBar = document.getElementById('scrollProgress');
var btt = document.getElementById('backToTop');

function onScroll() {
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var docHeight = document.documentElement.scrollHeight - window.innerHeight;
  if (progressBar && docHeight > 0) {
    progressBar.style.width = ((scrollTop / docHeight) * 100) + '%';
  }
  if (btt) {
    btt.classList.toggle('visible', scrollTop > 400);
  }
  // Header scroll class
  var header = document.querySelector('.ikick-header');
  if (header) header.classList.toggle('scrolled', scrollTop > 10);
}
if (btt) btt.addEventListener('click', function() { window.scrollTo({ top: 0, behavior: 'smooth' }); });
window.addEventListener('scroll', onScroll, { passive: true });

/* ══ 2. SCROLL REVEAL ═══════════════════════════════════════ */
var revealObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (e.isIntersecting) {
      e.target.classList.add('visible');
      revealObserver.unobserve(e.target);
    }
  });
}, { threshold: 0.08 });
document.querySelectorAll('.reveal').forEach(function(el) {
  revealObserver.observe(el);
});

/* ══ 3. MOBILE NAV ══════════════════════════════════════════ */
window.openNav = function() {
  document.querySelector('.ikick-nav-panel').classList.add('open');
  document.querySelector('.ikick-nav-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
};
window.closeNav = function() {
  document.querySelector('.ikick-nav-panel').classList.remove('open');
  document.querySelector('.ikick-nav-overlay').classList.remove('open');
  document.body.style.overflow = '';
};
var navOverlay = document.querySelector('.ikick-nav-overlay');
if (navOverlay) navOverlay.addEventListener('click', window.closeNav);
var hamBtn = document.querySelector('.ikick-ham-btn');
if (hamBtn) hamBtn.addEventListener('click', function() {
  this.classList.toggle('open');
  if (this.classList.contains('open')) window.openNav(); else window.closeNav();
});

/* ══ 4. SEARCH ══════════════════════════════════════════════ */
window.openSearch = function() {
  var overlay = document.querySelector('.ikick-search-overlay');
  if (overlay) {
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function() {
      var inp = document.querySelector('.ikick-srch-input');
      if (inp) inp.focus();
    }, 50);
  }
};
window.closeSearch = function() {
  var overlay = document.querySelector('.ikick-search-overlay');
  if (overlay) {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
};
var searchOverlay = document.querySelector('.ikick-search-overlay');
if (searchOverlay) {
  searchOverlay.addEventListener('click', function(e) {
    if (e.target === this) window.closeSearch();
  });
}
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    window.closeSearch();
    window.closeNav();
    ikickCloseCart();
  }
  if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
    e.preventDefault();
    window.openSearch();
  }
});

// Predictive search using Shopify API
var searchTimeout;
var searchInput = document.querySelector('.ikick-srch-input');
if (searchInput) {
  searchInput.addEventListener('input', function() {
    clearTimeout(searchTimeout);
    var q = this.value.trim();
    searchTimeout = setTimeout(function() {
      if (q.length >= 2) {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var results = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
            renderSearchResults(results, q);
          })
          .catch(function() {});
      }
    }, 250);
  });
}

function renderSearchResults(products, q) {
  var container = document.getElementById('ikickSearchResults');
  if (!container) return;
  if (products.length === 0) {
    container.innerHTML = '<p style="padding:20px;color:var(--muted);font-size:13px;">Aucun résultat pour "' + q + '"</p>';
    return;
  }
  var html = products.map(function(p) {
    var price = p.price ? (parseInt(p.price) / 100).toFixed(0) + ' €' : '';
    var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
    return '<a href="' + p.url + '" class="ikick-srch-side-prod" style="display:flex;align-items:center;gap:12px;padding:10px 0;border-bottom:1px solid var(--border);text-decoration:none;">' +
      (img ? '<div class="ikick-srch-side-thumb"><img src="' + img + '&width=88" alt=""></div>' : '') +
      '<div><div class="ikick-srch-side-brand">' + (p.vendor || '') + '</div>' +
      '<div class="ikick-srch-side-name">' + p.title + '</div></div>' +
      '<span class="ikick-srch-side-price" style="margin-left:auto;">' + price + '</span>' +
      '</a>';
  }).join('');
  container.innerHTML = html;
}

/* ══ 5. CART DRAWER (Shopify AJAX API) ════════════════════ */
function ikickRenderCart(cart) {
  var badge = document.querySelector('.ikick-cart-count');
  if (badge) badge.textContent = cart.item_count;

  var body = document.querySelector('.ikick-cd-body');
  var footer = document.querySelector('.ikick-cd-footer');
  var countBadge = document.querySelector('.ikick-cd-count-badge');
  if (countBadge) countBadge.textContent = cart.item_count;

  // Shipping bar
  var threshold = 5900; // 59€ in cents
  var fill = document.querySelector('.ikick-cd-ship-fill');
  var shipText = document.querySelector('.ikick-cd-ship-text');
  if (fill) fill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
  if (shipText) {
    var remaining = threshold - cart.total_price;
    shipText.innerHTML = remaining > 0
      ? 'Plus que <strong>' + (remaining/100).toFixed(0) + ' €</strong> pour la livraison offerte'
      : '<strong>🎉 Livraison offerte !</strong>';
  }

  if (!body) return;
  if (cart.item_count === 0) {
    body.innerHTML = '<div class="ikick-cd-empty"><div class="ikick-cd-empty-icon">👟</div><div class="ikick-cd-empty-title">Ton panier est vide</div><div class="ikick-cd-empty-sub">Découvre nos pépites et ajoute-en une !</div><a href="/collections/all" class="ikick-btn-lime" onclick="ikickCloseCart()">Voir la boutique</a></div>';
    if (footer) footer.style.display = 'none';
    return;
  }
  if (footer) footer.style.display = '';

  var html = cart.items.map(function(item) {
    return '<div class="ikick-cd-item" data-key="' + item.key + '">' +
      '<div class="ikick-cd-item-img"><img src="' + (item.image || '') + '" alt="' + item.product_title + '" loading="lazy"></div>' +
      '<div>' +
        '<div class="ikick-cd-item-brand">' + item.vendor + '</div>' +
        '<div class="ikick-cd-item-name">' + item.product_title + '</div>' +
        '<div class="ikick-cd-item-meta">' + (item.variant_title !== 'Default Title' ? item.variant_title : '') + '</div>' +
        '<div style="display:flex;align-items:center;gap:8px;margin-top:8px;">' +
          '<div style="display:flex;align-items:center;border:1px solid var(--border);">' +
            '<button class="ikick-cd-qty-btn" onclick="ikickUpdateCart(\'' + item.key + '\',' + (item.quantity - 1) + ')" style="width:28px;height:28px;background:none;border:none;cursor:pointer;font-size:14px;color:var(--muted);">−</button>' +
            '<span style="width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;border-left:1px solid var(--border);border-right:1px solid var(--border);">' + item.quantity + '</span>' +
            '<button class="ikick-cd-qty-btn" onclick="ikickUpdateCart(\'' + item.key + '\',' + (item.quantity + 1) + ')" style="width:28px;height:28px;background:none;border:none;cursor:pointer;font-size:14px;color:var(--muted);">+</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div style="display:flex;flex-direction:column;align-items:flex-end;justify-content:space-between;">' +
        '<div class="ikick-cd-item-price">' + (item.final_price / 100).toFixed(2).replace('.',',') + ' €</div>' +
        '<button class="ikick-cd-item-remove" onclick="ikickUpdateCart(\'' + item.key + '\',0)" title="Supprimer">✕</button>' +
      '</div>' +
    '</div>';
  }).join('');

  body.innerHTML = '<div style="padding:0;">' + html + '</div>';

  var subtotalEl = document.querySelector('.ikick-cd-subtotal-price');
  if (subtotalEl) subtotalEl.textContent = (cart.total_price / 100).toFixed(2).replace('.',',') + ' €';
}

function ikickFetchCart() {
  fetch('/cart.js').then(function(r) { return r.json(); }).then(ikickRenderCart).catch(function(){});
}

window.ikickUpdateCart = function(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(function(r) { return r.json(); }).then(ikickRenderCart).catch(function(){});
};

window.ikickOpenCart = function() {
  document.querySelector('.ikick-cart-drawer').classList.add('open');
  document.querySelector('.ikick-cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  ikickFetchCart();
};

window.ikickCloseCart = function() {
  document.querySelector('.ikick-cart-drawer').classList.remove('open');
  document.querySelector('.ikick-cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
};

var cartOverlay = document.querySelector('.ikick-cart-overlay');
if (cartOverlay) cartOverlay.addEventListener('click', window.ikickCloseCart);

// Wire cart buttons
document.querySelectorAll('.ikick-cart-btn').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.preventDefault(); window.ikickOpenCart();
  });
});

// Add to cart intercept
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (form && form.action && form.action.includes('/cart/add')) {
    e.preventDefault();
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data })
      .then(function(r) { return r.json(); })
      .then(function() {
        ikickFetchCart();
        window.ikickOpenCart();
        // Pulse cart button
        document.querySelectorAll('.ikick-cart-btn').forEach(function(b) {
          b.style.transform = 'scale(1.15)';
          setTimeout(function() { b.style.transform = ''; }, 300);
        });
      })
      .catch(function(err) { console.error(err); form.submit(); });
  }
});

/* ══ 6. COUNTDOWN TIMER ════════════════════════════════════ */
function initCountdown() {
  var target = document.getElementById('ikickCountdownTarget');
  if (!target) return;
  var endTime = new Date(target.dataset.end || Date.now() + 86400000 * 3).getTime();

  function tick() {
    var now = Date.now();
    var diff = endTime - now;
    if (diff <= 0) { clearInterval(timer); return; }
    var days  = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var mins  = Math.floor((diff % 3600000) / 60000);
    var secs  = Math.floor((diff % 60000) / 1000);
    var d = document.getElementById('cdDays');
    var h = document.getElementById('cdHours');
    var m = document.getElementById('cdMins');
    var s = document.getElementById('cdSecs');
    if (d) d.textContent = String(days).padStart(2,'0');
    if (h) h.textContent = String(hours).padStart(2,'0');
    if (m) m.textContent = String(mins).padStart(2,'0');
    if (s) s.textContent = String(secs).padStart(2,'0');
  }
  tick();
  var timer = setInterval(tick, 1000);
}

/* ══ 7. MEGA MENU ══════════════════════════════════════════ */
var megaLinks = document.querySelectorAll('.nav a[data-mega]');
var megaPanels = document.querySelectorAll('.mega');
var megaCloseTimer = null;

function closeMega() {
  megaPanels.forEach(function(p) { p.classList.remove('open'); });
  megaLinks.forEach(function(l) { l.classList.remove('mega-active'); });
}

megaLinks.forEach(function(link) {
  link.addEventListener('mouseenter', function() {
    clearTimeout(megaCloseTimer);
    var key = link.getAttribute('data-mega');
    var panel = document.getElementById('mega-' + key);
    closeMega();
    if (panel) {
      panel.classList.add('open');
      link.classList.add('mega-active');
    }
  });
  link.addEventListener('mouseleave', function() {
    var key = link.getAttribute('data-mega');
    var panel = document.getElementById('mega-' + key);
    megaCloseTimer = setTimeout(function() {
      if (panel && !panel.matches(':hover')) closeMega();
    }, 100);
  });
});

megaPanels.forEach(function(panel) {
  panel.addEventListener('mouseenter', function() { clearTimeout(megaCloseTimer); });
  panel.addEventListener('mouseleave', function() {
    megaCloseTimer = setTimeout(closeMega, 100);
  });
});

/* ══ 8. BRANDS FILTER BAR ═══════════════════════════════════ */
document.querySelectorAll('.ikick-brand-tab').forEach(function(tab) {
  tab.addEventListener('click', function() {
    document.querySelectorAll('.ikick-brand-tab').forEach(function(t) { t.classList.remove('active'); });
    this.classList.add('active');
  });
});

/* ══ 9. IMAGE LAZY SKELETON ══════════════════════════════════ */
document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
  if (!img.complete) {
    img.style.background = 'linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)';
    img.style.backgroundSize = '400px 100%';
    img.addEventListener('load', function() { img.style.background = ''; });
    img.addEventListener('error', function() { img.style.background = '#f2f2f2'; });
  }
});

/* ══ 10. INIT ══════════════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function() {
  onScroll();
  initCountdown();
  ikickFetchCart();
});
// reveal handled by IntersectionObserver above

})();
